import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import Tooltip from 'react-tooltip'
import moment from 'moment'

import { holeHelper } from '../../helpers'
import { uiConstants, envConstants } from '../../constants'
import { certifyPhoto, riparablePhoto, repairedPhoto } from '../../actions'
import Dima from '../../assets/dima1.png'

const initialState = {
  res: uiConstants.imageQuality.medium,
  showDima: false
}

class ImageViewer extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  changeRes() {
    this.setState({
      res:
        this.state.res === uiConstants.imageQuality.medium
          ? uiConstants.imageQuality.high
          : uiConstants.imageQuality.medium
    })
  }

  nextImage(dir) {
    // const s = this.state
    // const nid = s.imageIndex + dir
    // const { images, onlyCertifiedImages } = this.props.dashboard
    // const list = holeHelper.groupImages((images || []))
    //           .filter(x => {
    //             return (onlyCertifiedImages) ? x.certified === 1 : true
    //           })
    // if (nid >= 0 && nid < list.length) {
    //   this.setState({
    //     imageIndex: nid
    //   })
    // }
    // const imageIndex = this.props.dashboard.images.findIndex(x => x.guid === image.guid)
  }

  render() {
    const s = this.state
    const filteredImages = this.props.filteredImages
    const index = this.props.imageIndex
    const i = filteredImages[index]
    return (
      <>
        <div
          className='search-form-bkg'
          onClick={() => this.props.showImageForm()}
        ></div>
        <div className='image-container'>
          <Tooltip id='zoomIn' effect='solid' className='nav-tip-upper'>
            Zoom in
          </Tooltip>
          <Tooltip id='zoomOut' effect='solid' className='nav-tip-upper'>
            Zoom out
          </Tooltip>
          <Tooltip id='originalSize' effect='solid' className='nav-tip-upper'>
            reset zoom
          </Tooltip>
          <Tooltip
            id='changeResolution'
            effect='solid'
            className='nav-tip-upper'
          >
            Cambia risoluzione
          </Tooltip>
          <Tooltip id='close' effect='solid' className='nav-tip-upper'>
            Chiudi
          </Tooltip>
          <Tooltip id='certified' effect='solid' className='nav-tip-upper'>
            Valida
          </Tooltip>
          <Tooltip id='riparable' effect='solid' className='nav-tip-upper'>
            Riparabile
          </Tooltip>
          <Tooltip id='repaired' effect='solid' className='nav-tip-upper'>
            Foto riparazione
          </Tooltip>
          <Tooltip id='dima' effect='solid' className='nav-tip-upper'>
            Dima
          </Tooltip>
          <Tooltip id='download' effect='solid' className='nav-tip-upper'>
            Download
          </Tooltip>
          <TransformWrapper
            defaultScale={1}
            defaultPositionX={100}
            defaultPositionY={100}
          >
            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
              <React.Fragment>
                <div className='image-info-container'>
                  <ul className='image-ld'>
                    <li>
                      <i className='fas fa-list-ol'></i>
                      {index + 1}/{filteredImages.length}
                    </li>
                    <li>
                      <i className='fas fa-location-arrow'></i>
                      {i.latitude}, {i.longitude}
                    </li>
                    <li>
                      <i className='fas fa-map-marked-alt'></i>
                      {i.address}
                    </li>
                    <li>
                      <i className='far fa-clock'></i>
                      {moment
                        .unix(i.mediadate)
                        .format(envConstants.momentFormat)}
                    </li>
                    {/* <li>
                      {
                        (i.holes || []).map((h, index) => {
                          const hole = this.props.dashboard.list.filter(x => x.id === h)
                          console.log(hole)
                          if (hole.length > 0) {
                            return (
                              <button key={index} className="btn-hole-from-image" onClick={() => this.props.goAnomaly(hole.id)}>
                                <img src={holeHelper.holeMarker(hole[0])} alt={hole[0].severity} /> {hole[0].id}
                              </button>
                            )
                          }
                        })
                      }
                    </li> */}
                  </ul>
                  <ul className='image-tools'>
                    <li>
                      <button
                        onClick={() => this.props.repairedPhoto({ id: i.id })}
                        data-tip=''
                        data-for='repaired'
                        className={
                          'btn-image-tools ' +
                          (i.repaired === 0 ? '' : 'certified')
                        }
                      >
                        <i className='fas fa-briefcase-medical'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => this.props.riparablePhoto({ id: i.id })}
                        data-tip=''
                        data-for='riparable'
                        className={
                          'btn-image-tools ' +
                          (i.riparable === 0 ? '' : 'certified')
                        }
                      >
                        <i className='fas fa-hammer'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => this.props.certifyPhoto({ id: i.id })}
                        data-tip=''
                        data-for='certified'
                        className={
                          'btn-image-tools ' +
                          (i.certified === 0 ? '' : 'certified')
                        }
                      >
                        <i className='far fa-star'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='btn-image-tools'
                        data-tip=''
                        data-for='zoomOut'
                        onClick={zoomOut}
                      >
                        <i className='fas fa-search-minus'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='btn-image-tools'
                        data-tip=''
                        data-for='zoomIn'
                        onClick={zoomIn}
                      >
                        <i className='fas fa-search-plus'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='btn-image-tools'
                        data-tip=''
                        data-for='originalSize'
                        onClick={resetTransform}
                      >
                        <i className='fas fa-expand'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='btn-image-tools'
                        data-tip=''
                        data-for='changeResolution'
                        onClick={() => this.changeRes()}
                      >
                        <i className='fas fa-random'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className={
                          'btn-image-tools ' + (s.showDima ? 'certified' : '')
                        }
                        data-tip=''
                        data-for='dima'
                        onClick={() => this.setState({ showDima: !s.showDima })}
                      >
                        <i className='fas fa-ruler-combined'></i>
                      </button>
                    </li>
                    <li>
                      <a
                        href={holeHelper.imageMarker(i.guid, s.res)}
                        className={'btn-image-tools'}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label='Download'
                        data-tip=''
                        data-for='download'
                      >
                        <i className='fas fa-download'></i>
                      </a>
                    </li>
                    <li>
                      <button
                        className='btn-image-tools'
                        data-tip=''
                        data-for='close'
                        onClick={() => this.props.showImageForm()}
                      >
                        <i className='fas fa-times'></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <div className='image-arrow'>
                  <ul>
                    <li>
                      <button onClick={() => this.props.endsImage(1)}>
                        <i className='fas fa-angle-double-up'></i>
                      </button>
                    </li>
                    <li>
                      <button onClick={() => this.props.nextImage(1)}>
                        <i className='fas fa-angle-up'></i>
                      </button>
                    </li>
                    <li>
                      <button onClick={() => this.props.nextImage(-1)}>
                        <i className='fas fa-angle-down'></i>
                      </button>
                    </li>
                    <li>
                      <button onClick={() => this.props.endsImage(-1)}>
                        <i className='fas fa-angle-double-down'></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <TransformComponent>
                  <div className='image-viewer-container'>
                    <img
                      src={holeHelper.imageMarker(i.guid, s.res)}
                      alt={'drone photo ' + s.res}
                      className='photo'
                    />
                    {s.showDima && (
                      <img src={Dima} alt='dima' className='dima' />
                    )}
                  </div>
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
        </div>
      </>
    )
  }
}
function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  certifyPhoto,
  riparablePhoto,
  repairedPhoto
})(ImageViewer)
